"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBboxParts = void 0;
var isBboxParts = function (value) {
    return value !== undefined &&
        value !== 'background' &&
        value.type !== 'face' &&
        value.type !== 'paint';
};
exports.isBboxParts = isBboxParts;
